<template>
    <common-dialog ref="commonDialog"
                   :buttons="[{
                   id: 'ok',
                   html: 'OK',
                   classes: 'btn-outline-dark',
                   dismiss: true
                   }]"
                   @shown="shown"
                   @hidden="hidden">
    </common-dialog>
</template>
<script>

    import CommonDialog from '../components/Dialog/CommonDialog'

    export default {
        components: {
            CommonDialog
        },
        data: function () {
            return {
                title: 'Error',
                message: ''
            };
        },
        methods: {
            show() {
                let icon = '';
                if (this.title == 'Error') {
                    icon = '<i class="fa fa-warning me-2 text-danger"></i>'
                }
                this.$refs.commonDialog.show({
                    title: icon + this.title,
                    body: this.message
                });
            },
            shown() {
            },
            hide() {
                this.$refs.commonDialog.hide();
            },
            hidden() {
            },
        },
        created() {
            const vm = this;
            Events.on(Events.error, (data) => {
                let title = 'Error';
                let message = '';
                if (typeof (data) === 'string') {
                    message = data;
                } else {
                    if (data?.message) message = data.message;
                    if (data?.title) title = data.title;
                }
                vm.title = title;
                vm.message = message;
                vm.show();
            });
        }
    };
</script>